import PropTypes from 'prop-types';
import { useState } from 'react';
import { BsTagFill } from 'react-icons/bs';
import VirtuosoPromotionsModal from './VirtuosoPromotionsModal';

/**
 * Themed rather than a fixed brand colour: `theme` resolves to the viewing agency's palette,
 * so this picks up the agency's own colours instead of the generic red that read as a
 * discount sticker.
 *
 * Tailwind here is 1.9.5: there is no slash-opacity (`bg-theme/5`), no `px-2.5` and no
 * `gap-*`/`shrink-0`. Those compile to nothing, which is why an earlier attempt rendered with
 * no padding at all. Solid fill and `mr-1` on the icon keep this within the v1 utility set.
 */
const CHIP =
  'inline-flex items-center rounded-full bg-theme px-3 py-1 text-xs font-semibold text-white';

/** Names the source of the offer — "Promotion(s)" alone said nothing about whose it is. */
const LABEL = 'Virtuoso promotions';

/** Virtuoso promotions affordance on a sailing. Opens the offer detail in place. */
const VirtuosoPromotions = ({ virtuosoVoyage }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setIsOpen(true)} className={CHIP}>
        <BsTagFill className="mr-1 flex-shrink-0" aria-hidden="true" />
        {LABEL}
      </button>
      {isOpen && (
        <VirtuosoPromotionsModal
          virtuosoVoyage={virtuosoVoyage}
          open={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

VirtuosoPromotions.propTypes = {
  virtuosoVoyage: PropTypes.shape().isRequired,
};

export default VirtuosoPromotions;
